export default {
  labels: {
    reply: 'Resposta do Proprietário',
  },
  form: {
    reply_text: {
      placeholder: 'Escreva a sua resposta...',
    },
  },
  buttons: {
    generate_reply: 'Gerar resposta',
    submit_reply: 'Submeter resposta',
  },
  toasts: {
    failed_to_create_reply: 'Falha ao criar resposta',
    failed_to_generate_ai_reply: 'Falha ao gerar resposta com IA',
  },
};
